export const BEACON_VRB_EVENT = 'BEACON:VISUAL_RULE_BUILDER';
